import { z } from 'zod';
import { Contact, Place } from './common';
export var ProfessionalHelpContact = Contact;
export var ProfessionalHelpPlace = Place;
export var ProfessionalHelpContactAndPlace = z.object({
    contact: ProfessionalHelpContact,
    location: ProfessionalHelpPlace
});
export var ProfessionalHelpContacts = z.array(ProfessionalHelpContactAndPlace).prefault([]);
